export default {
  ASC: 'ascending',
  DESC: 'descending',
}
